import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { SolutionSection } from './SolutionSection';
import { BenefitsSection } from './BenefitsSection';
import { PricingSection } from './PricingSection';
import { FAQSection } from './FAQSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#faf6f0] font-sans text-[#5a5a5a] selection:bg-[#c4956a]/30" data-id="element-148">
      <HeroSection data-id="element-149" />
      <PainSection data-id="element-150" />
      <SolutionSection data-id="element-151" />
      <BenefitsSection data-id="element-152" />
      <PricingSection data-id="element-153" />
      <FAQSection data-id="element-154" />
      <Footer data-id="element-155" />
    </div>;
}